import { Link } from "react-router-dom";

export default function BuildingCard({ building }) {
  const { slug, name, area, isNew, heroImageUrl } = building;

  return (
    <Link
      to={`/our-locations/${slug}`}
      className="group block bg-white overflow-hidden"
    >
      <div className="relative aspect-[4/3] bg-gray-100 overflow-hidden">
        <img
          src={heroImageUrl}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          onError={(e) => {
            e.target.src = "https://www.artistic-spaces.co.uk/assets/default-property-image.png";
          }}
        />
        {isNew && (
          <div className="absolute top-0 left-0 right-0 bg-gray-700/80 text-white text-sm font-semibold tracking-widest uppercase px-4 py-2">
            NEW LOCATION
          </div>
        )}
      </div>
      <div className="px-4 py-4">
        <h3 className="text-base font-semibold text-gray-900 group-hover:text-teal-700 transition-colors duration-200">
          {name}
        </h3>
        <p className="text-base text-gray-500 mt-0.5">{area}</p>
      </div>
    </Link>
  );
}